module.exports = __webpack_public_path__ + "img/chongci_ps_04.bf7764ae.jpg";